export function setProductos(state, productos) {
    state.productos = productos;
}

export function setProductoSelec(state, producto) {
    state.productoSelec = producto;
}

export function actListProductos(state, producto) {
    if (producto !== null) {
        const index = state.productos.findIndex(r => r.id === producto.id)
        if (index != -1) {
            const stockFisico = producto.stock_fisico != null ? producto.stock_fisico : producto.stock_actual;
            state.productos[index].codigo = producto.codigo;
            state.productos[index].nombre = producto.nombre;
            if (stockFisico != null) {
                state.productos[index].stock_fisico = stockFisico;
            }
            state.productos[index].stock_reservado = producto.stock_reservado;  
            state.productos[index].stock_disponible = producto.stock_disponible;  
            state.productos[index].stock_minimo = producto.stock_minimo;  
            state.productos[index].requiere_reposicion = producto.requiere_reposicion;  
            state.productos[index].unidad_medida = producto.unidad_medida;
        }
    }
}

export function actDeleteListProductos(state, id) {
    if (id != null) {
        const index = state.productos.findIndex(r => r.id === id)
        if (index != -1) {
            state.productos.splice(index, 1)
        }
    }
}
